export default __webpack_public_path__ + "static/media/office1-before1-1920w.8ab58949.png";